export default {
  GetWebHeadList: '/Controllers/Web/Webcommon/WebApiCommon/GetWebHeadList',
  GetWebFootList: '/Controllers/Web/Webcommon/WebApiCommon/GetWebFootList',
  GetWebHomeBannerList: '/Controllers/Web/WebHome/ApiWebHome/GetWebHomeBannerList',
  GetWebHomeProductCategoryList: '/Controllers/Web/WebHome/ApiWebHome/GetWebHomeProductCategoryList',
  GetWebHomeVideoIntroduction: '/Controllers/Web/WebHome/ApiWebHome/GetWebHomeVideoIntroduction',
  GetCityList: '/Controllers/Web/WebShops/ApiWebShops/GetCityList',
  GetAreaList: '/Controllers/Web/WebShops/ApiWebShops/GetAreaList?value=',
  GetWebNewMessageList: '/Controllers/Web/WebNewMessages/ApiWebNewMessage/GetWebNewMessageList',
  GetWebNewMessage: '/Controllers/Web/WebNewMessages/ApiWebNewMessage/GetWebNewMessage?Id=',
  GetTypeList: '/Controllers/Web/WebNewMessages/ApiWebNewMessage/GetTypeList',
  _GetWebShopList: '/Controllers/Web/WebShops/ApiWebShops/GetWebShopList',
  get GetWebShopList() {
    return this._GetWebShopList;
  },
  set GetWebShopList(value) {
    this._GetWebShopList = value;
  },
  getProductType: '/Controllers/Web/WebProducts/ApiWebProducts/GetTypeList',
  getProductList: '/Controllers/Web/WebProducts/ApiWebProducts/GetWebProductsList',
  getProductDetail: '/Controllers/Web/WebProducts/ApiWebProducts/GetWebProducts',
  GetActivitysList: '/Controllers/Web/WebShops/ApiWebShops/GetActivitysList',
  GetPaymentList: '/Controllers/Web/WebShops/ApiWebShops/GetPaymentList',
  postFeedback: '/Controllers/Web/WebContact/WebContact/SendOpinion',
  postJoin: '/Controllers/Web/WebContact/ApiWebContact/SendJoin',
  GetWebFoundationNewList: '/Controllers/Web/WebFoundation/ApiWebFoundation/GetWebFoundationNewMessageList',
  GetWebFoundationNew: '/Controllers/Web/WebFoundation/ApiWebFoundation/GetWebFoundationNewMessage?Id=',
  GetWebFoundationDonorList: '/Controllers/Web/WebFoundation/ApiWebFoundation/GetWebFoundationDonorList',
  getWebHomeProductList: '/Controllers/Web/WebHome/ApiWebHome/GetWebHomeProductList',
  createValidateGraphic: 'Controllers/Web/WebContact/ApiWebContact/CreateValidateGraphic',
  UploadFile: 'Controllers/Web/WebContact/ApiWebContact/WebUploadFile',
  getInvestorType: '/Controllers/Web/WebInvestor/ApiWebInvestor/GetTypeList',
  getInvestorList: '/Controllers/Web/WebInvestor/ApiWebInvestor/GetWebInvestorList',
  getInvestorDetail: '/Controllers/Web/WebInvestor/ApiWebInvestor/GetWebInvestor',
  getESGType: '/Controllers/Web/WebESG/ApiWebESG/GetTypeList',
  getESGList: '/Controllers/Web/WebESG/ApiWebESG/GetWebESGList',

}



// WEBPACK FOOTER //
// ./src/components/config/api.js